import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    flexInput: { margin: theme.spacing(1), flexGrow: "1", flexBasis: "100%" }
}));
